<template>
  <div class="delete-transaction-confirm">
    <div class="delete-transaction-confirm__title">
      {{ $t('transaction.delete_confirm_title') }}
    </div>
    <div class="delete-transaction-confirm__text">
      {{ $t('transaction.delete_confirm_text') }}
    </div>
    <div class="delete-transaction-confirm__buttons">
      <button
        class="delete-transaction-confirm__button delete-transaction-confirm__button--confirm"
        :disabled="isDeleting"
        @click="handleConfirm"
      >
        {{ $t('button_props.yes') }}
      </button>
      <button
        class="delete-transaction-confirm__button delete-transaction-confirm__button--cancel"
        :disabled="isDeleting"
        @click="handleCancel"
      >
        {{ $t('button_props.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteTransactionConfirm',
  data() {
    return {
      isDeleting: false,
    };
  },
  computed: {
    transactionId() {
      return this.$store.state.Dialog.transactionToDelete;
    },
  },
  methods: {
    async handleConfirm() {
      if (!this.transactionId) return;

      this.isDeleting = true;
      try {
        await this.$store.dispatch('Ad/deleteTransaction', {
          businessAccountId: this.$store.state.Auth.activeAccount.id,
          transactionId: this.transactionId,
        });

        // Эмитим событие для обновления списка
        this.$root.$emit('transaction-deleted');

        // Закрываем диалог
        this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: false });
        this.$store.commit('Dialog/setData', { label: 'transactionToDelete', data: null });

        // Показываем уведомление об успехе
        this.$notify({
          message: this.$t('transaction.delete_success'),
          type: 'success',
        });
      } catch (error) {
        console.error('Error deleting transaction:', error);
        this.$notify({
          message: this.$t('transaction.delete_error'),
          type: 'error',
        });
      } finally {
        this.isDeleting = false;
      }
    },
    handleCancel() {
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: false });
      this.$store.commit('Dialog/setData', { label: 'transactionToDelete', data: null });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.delete-transaction-confirm {
  min-width: 40rem;

  &__title {
    font-weight: 700;
    font-size: 2rem;
    line-height: 2.3rem;
    color: $basicBlack;
    margin-bottom: 1.5rem;
  }

  &__text {
    font-size: 1.6rem;
    line-height: 1.9rem;
    color: $gray2;
    margin-bottom: 3rem;
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 1.5rem;
  }

  &__button {
    padding: 1rem 2.4rem;
    border-radius: 4px;
    font-size: 1.6rem;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &--confirm {
      background-color: $redLight;
      color: $basicWhite;

      &:hover:not(:disabled) {
        background-color: darken($redLight, 10%);
      }
    }

    &--cancel {
      background-color: $basicWhite;
      color: $basicBlack;
      border: 1px solid #d1d4d8;

      &:hover:not(:disabled) {
        background-color: #f6f7f9;
      }
    }
  }

  @include below(769px) {
    padding: 2rem;
    min-width: auto;

    &__title {
      font-size: 1.8rem;
      margin-bottom: 1rem;
    }

    &__text {
      font-size: 1.4rem;
      margin-bottom: 2rem;
    }

    &__buttons {
      flex-direction: column-reverse;
      gap: 1rem;
    }

    &__button {
      width: 100%;
      padding: 1.2rem 2rem;
    }
  }
}
</style>
